import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormField } from '../../../dto/util/form-field';
import { FormGroup, Validators } from '@angular/forms';
import { FormPersonaNaturalDto } from '../dto/form-persona-natural.dto';
import { Constants } from '../../../constants/constants';

@Component({
  selector: 'app-form-persona-natural',
  templateUrl: './form-persona-natural.component.html',
  styleUrl: './form-persona-natural.component.scss',
})
export class FormPersonaNaturalComponent implements OnChanges, OnInit {
  @Input() camposOcultos: string[] = [];
  @Input() camposInhabilitados: string[] = [];
  @Input() withSubmitButton = true;
  @Input() data: FormPersonaNaturalDto = {};
  @Output() changeAction = new EventEmitter<FormGroup>();
  @Output() submitAction = new EventEmitter<FormGroup>();

  formFields: FormField[] = [];

  allFields: FormField[] = [
    {
      name: 'firstName',
      label: 'Primer Nombre',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer nombre ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      tooltip: 'Hola estoy es un tooltip',
      tooltipPosition: 'top',
      errorMessages: {
        required: 'Nombre es requerido',
        maxlength: 'Nombre no puede superar los 25 caracteres',
      },
      value: this.data?.firstName,
      modalVisibility: true,
      titleModal: 'Hola este es un modal de texto',
      sizeModal: 'lg',
      contentTypeModal: 'text',
      contentModalText:
        'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    },
    {
      name: 'secondName',
      label: 'Segundo Nombre',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo nombre ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      tooltip: 'Hola estoy es un tooltip',
      tooltipPosition: 'top',
      errorMessages: { maxlength: 'Nombre no puede superar los 25 caracteres' },
      value: this.data?.secondName,
      modalVisibility: true,
      titleModal: 'Hola este es un modal de lista',
      sizeModal: 'lg',
      contentTypeModal: 'list',
      contentModalList: ['Uno', 'Dos', 'Tres', 'Cuatro', 'Cinco'],
    },
    {
      name: 'firstLastName',
      label: 'Primer Apellido',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su primer apellido ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        required: 'Apellido es requerido',
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data?.firstLastName,
      modalVisibility: true,
      titleModal: 'Hola este es un modal de image',
      sizeModal: 'lg',
      contentTypeModal: 'image',
      contentModalImage: 'https://picsum.photos/200/300',
    },
    {
      name: 'secondLastName',
      label: 'Segundo Apellido',
      type: 'text',
      required: false,
      placeholder: 'Ingrese su segundo apellido ',
      width: '6',
      visible: true,
      validation: [Validators.maxLength(25)],
      errorMessages: {
        maxlength: 'Apellido no puede superar los 25 caracteres',
      },
      value: this.data?.secondLastName,
    },
    {
      name: 'typeOfDocument_1',
      label: 'Tipo de documento',
      type: 'select',
      multiple: false,
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El documento es requerido' },
      value: this.data?.typeOfDocument,
    },
    {
      name: 'numberOfDocument',
      label: 'Identificación',
      type: 'text',
      required: true,
      placeholder: 'Ingrese su número de documento',
      width: '6',
      visible: true,
      errorMessages: {
        required: 'Número de documento requerido',
      },
      value: this.data?.numberOfDocument,
    },
    {
      name: 'phone',
      label: 'Teléfono de contacto',
      type: 'text',
      required: true,
      placeholder: 'Ingrese el teléfono',
      width: '6',
      visible: true,
      validation: [
        Validators.minLength(6),
        Validators.maxLength(15),
        Validators.pattern(Constants.REGEX_TELEFONO),
      ],
      errorMessages: {
        required: 'El teléfono es requerido',
        minlength: 'Teléfono de contacto debe contener mínimo 6 dígitos.',
        maxlength: 'Teléfono de contacto no puede superar los 15 dígitos.',
        pattern:
          'Teléfono de contacto solo debe contener números; no se permiten espacios ni caracteres especiales.',
      },
    },
    {
      name: 'address',
      label: 'Dirección de notificación judicial',
      type: 'text',
      required: true,
      placeholder: 'Ingrese la dirección',
      width: '6',
      visible: true,
      errorMessages: { required: 'La dirección es requerida' },
    },
    {
      name: 'email',
      label: 'Correo electrónico',
      type: 'email',
      required: true,
      placeholder: 'Ingrese su correo electrónico',
      width: '6',
      visible: true,
      validation: [Validators.email],
      errorMessages: {
        required: 'Email es requerido',
        email: 'Formato de correo invalido',
      },
      value: this.data?.email,
    },
    {
      name: 'country',
      label: 'País',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El país es requerido' },
      value: this.data?.country,
    },
    {
      name: 'departament',
      label: 'Departamento',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'El departamento es requerido' },
      value: this.data?.departament,
    },
    {
      name: 'municipality',
      label: 'Municipio/ciudad',
      type: 'select',
      required: true,
      options: [],
      width: '6',
      visible: true,
      errorMessages: { required: 'Municipio/ciudad es requerido' },
      value: this.data?.municipality,
    },
    {
      name: 'textAreaTesting',
      label: 'Texto de prueba',
      type: 'textarea',
      required: false,
      placeholder: 'Ingrese un texto de prueba',
      width: '12',
      visible: true,
    },
    {
      name: 'SelectMultipleTesting',
      label: 'Multiple de prueba',
      type: 'select',
      multiple: true,
      required: false,
      options: [
        { Nombre: 'Sí', Id: 1 },
        { Nombre: 'No ', Id: 2 },
      ],
      width: '6',
      visible: true,
    },
  ];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['camposOcultos']) {
      this.formFields = this.allFields.filter(
        field => !this.camposOcultos.includes(field.name)
      );
    }
  }

  ngOnInit() {
    this.formFields = this.allFields
      .filter(field => !this.camposOcultos.includes(field.name))
      .map(field => {
        if (this.camposInhabilitados.includes(field.name)) {
          field.disabled = true;
        }

        if (this.data[field.name as keyof typeof this.data] !== undefined) {
          field.value = this.data[field.name as keyof typeof this.data];
        }

        return field;
      });
  }

  onSubmit(form: FormGroup): void {
    this.submitAction.emit(form);
  }

  onChanges(form: FormGroup): void {
    this.changeAction.emit(form);
  }
}
